class ViewSharedStateStorage {

  constructor(keyName) {
    this.keyName = keyName;
  }

  saveStateMutation(processedState, viewManager, viewType) {
    const sharedState = processedState[this.keyName];
    const selectedView = viewManager.renderState.selectedView;
    const defaultView = viewManager.getDefaultViewByType(selectedView.viewType);
    const defaultViewStateForType = defaultView.viewState;
    defaultView.viewState = { ...defaultViewStateForType, [viewType]: sharedState };
  }

}

export default ViewSharedStateStorage;